import { render, staticRenderFns } from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=template&id=bd235870&scoped=true&"
import script from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=0&id=bd235870&prod&scoped=true&lang=css&"
import style1 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=1&id=bd235870&prod&lang=scss&scoped=true&"
import style2 from "./RiskConferenceWarningAlwaysUpdate.vue?vue&type=style&index=2&id=bd235870&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd235870",
  null
  
)

export default component.exports